module.exports = __webpack_public_path__ + "static/media/98mmInox.b48c930e.png";